import { FC } from 'react';

// assets
import style from '../assets/style/layout/bonusDialog.module.scss';
import dialogStyle from '../assets/style/layout/dialog.module.scss';

// function component
type Props = {
  doClose: () => void; // 閉じる
};
export const BonusDialog: FC<Props> = ({ doClose }) => {
  return (
    <>
      <figure className={style.figure}>
        <img src="/assets/images/shimaenagaChan/yay.png" alt="" className={style.image} />
      </figure>
      <p className={`${style.paragraph} ${style.tada}`}>
        <span className={style.block}>
          <span className={style.shortCopy}>登録ありがとう！</span>
          <strong className={style.pointGet}>10ポイントGET！</strong>
        </span>
      </p>
      <button className={dialogStyle.button} type="button" onClick={doClose}>
        閉じる
      </button>
    </>
  );
};
